import { useAppSelector } from "@/reducers/hooks"
import { useMemo } from "react"
import { findActivity } from "@/reducers/activitySlice"

export default function useDriverCurrentActivity(
  driverJid: string,
): string | undefined {
  const activity = useAppSelector(findActivity(driverJid))
  return useMemo(() => activity?.specific, [activity?.specific])
}
